import React, { useEffect, useState } from 'react';
import { Stack, Alert, Snackbar, Slide } from '@mui/material';

function TransitionUp(props: React.ComponentProps<typeof Slide>) {
  return <Slide {...props} direction='up' />;
}

interface ErrorSnackBarProps {
  message: string | null | undefined;
  onClear: () => void;
}

export default function ErrorSnackBar({ message, onClear }: ErrorSnackBarProps) {
  const [open, setOpen] = useState(Boolean(message));

  useEffect(() => {
    setOpen(Boolean(message));
  }, [message]);

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClear();
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      slots={{
        transition: TransitionUp,
      }}
    >
      <Stack direction='row' spacing={2}>
        <Alert onClose={handleClose} severity='error' sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Stack>
    </Snackbar>
  );
}

